// Overriden swagger generated model

export enum ComparisonOperator {
    Eq = '=',
    Ge = '>=',
    Gt = '>',
    Ne = '!=',
    Lt = '<',
    Le = '<=',
}
